import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Space, theme } from 'antd';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';

const TOTAL_FIELD_COUNT = 7;
const { RangePicker } = DatePicker;

export default function SolutionsFilterPanel({ userData, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const buttonColLayout = computeButtonColLayout(TOTAL_FIELD_COUNT);

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Card
            size="small"
            className="eha-solutions-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="解决方案名称" name="title" style={filterFormItemStyle}>
                            <Input allowClear placeholder="解决方案名称关键字" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="发布者昵称" name="nickName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="企业用户昵称" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="发布者手机" name="mobile" style={filterFormItemStyle}>
                            <Input allowClear placeholder="企业用户手机" autoComplete="off" />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="提交时间" name="createdAt" style={filterFormItemStyle}>
                            <RangePicker className="ProjectRangPicker" allowClear showTime />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="审核时间" name="reviewedAt" style={filterFormItemStyle}>
                            <RangePicker className="ProjectRangPicker" allowClear showTime />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="审核状态" name="reviewStatus" style={filterFormItemStyle}>
                            <Select
                                placeholder="请选择审核状态"
                                options={[
                                    { value: -1, label: '全部' },
                                    { value: 0, label: '待审核' },
                                    { value: 1, label: '审核通过' },
                                    { value: 2, label: '审核驳回' },
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="审核管理员" name="reviewedBy" style={filterFormItemStyle}>
                            <Select
                                placeholder="请选择审核管理员"
                                showSearch={{
                                    optionFilterProp: 'children',
                                }}
                            >
                                {userData?.map(item => (
                                    <Select.Option key={item.phone} value={item.phone} data={item}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
